import { render, staticRenderFns } from "./ReportItem.vue?vue&type=template&id=9797fac0&scoped=true&"
import script from "./ReportItem.vue?vue&type=script&lang=ts&"
export * from "./ReportItem.vue?vue&type=script&lang=ts&"
import style0 from "./ReportItem.vue?vue&type=style&index=0&id=9797fac0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9797fac0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCol,VDivider,VIcon,VRow})
